import styleConstants from 'style-constants.scss';

export const tableColumns = [
    { name: 'Name', value: 'fullName', isSortable: true, langKey: "name-text" },
    { name: 'E-mail', value: 'email', isSortable: true, langKey: "email" },
    { name: 'Speciality', value: "speciality", isSortable: true, langKey: "speciality" },
    { name: 'Experience', value: "experienceSince", isSortable: true, langKey: "experience" },
    { name: 'Applications', value: "applications", isSortable: true, langKey: "applications" },
    { name: 'Status', value: 'status', isSortable: true, langKey: "status" },
];

export const defaultTableColumns = ['fullName', 'email', 'speciality', 'experienceSince', 'applications', 'status'];

export const DEVELOPER = 'Developer';
export const JAVA = 'Java';
export const PYTHON = 'Python';
export const CSHARP = 'C#';
export const JAVASCRIPT = 'JavaScript';
export const RUBY = 'Ruby';
export const OTHER = 'Other';

export const tableTabs = [
    { name: "Applicant Pipeline", value: "applicantPipeline", langKey: "applicant-pipeline" },
    { name: "Vetted", value: "vetted", langKey: "vetted-plural" },
    { name: "Rejected", value: "rejected", langKey: "rejected-plural" },
    { name: "Incomplete Profile", value:"incompleteProfile", langKey: "incomplete-profile-plural" },
];

export const legendItems = [
    { color: styleConstants.yellowLight, text: "Registered via link", langKey: "registration-link" },
    { color: styleConstants.greenLight, text: "Invited by the admin", langKey: "invited-by-admin" },
    { color: styleConstants.blueLight, text: "LinkedIn", langKey: "linkedin-text" },
    { color: styleConstants.purple, text: "Google", langKey: "google-text" },
    { color: styleConstants.greyDark, text: "Other", langKey: "other" },
];

export const defaultTab = tableTabs[0];

export const tableFilters = [
    { key: 'status', name: 'Status', value: ['New', 'CV Completed', 'Pending Video Review', 'Pending Calendly Review'], hasTranslation: true },
    { key: 'speciality', name: 'Speciality', value: [JAVA, PYTHON, CSHARP, JAVASCRIPT, RUBY, OTHER], hasTranslation: true },
];

export const PAGE_QUERY_SELECTOR = 'page';
export const SORT_QUERY_SELECTOR = 'sort';
export const TABS_QUERY_SELECTOR = 'tab';

export const INITIAL_QUERY = {
    page: 1,
    filters: JSON.stringify({}),
    tab: "applicantPipeline",
    sortBy: null,
    sortByDir: null,
    pagesToLoad: 5,
    itemsPerPage: 25,
};

export const QUERY_MAP = {
    page: PAGE_QUERY_SELECTOR,
    filters: "filters",
    tab: TABS_QUERY_SELECTOR,
    sortBy: SORT_QUERY_SELECTOR,
    sortByDir: `${SORT_QUERY_SELECTOR}Dir`,
};

export const DEFAULT_CANDIDATE_ASSIGNEE_SELECT = { value: 1, name: 'All Assignees' };
export const DEFAULT_CANDIDATE_SPECIALITY_SELECT = { value: 1, name: 'All Specialities' };
export const DEFAULT_CANDIDATE_STATUS_SELECT = { value: 1, name: 'All' };
